import axios, { AxiosResponse } from "axios";
import { GeocodeError } from "@/services/error_service";

/**
 * Creates a new geocode Service
 * Using Mapquest's Geocode API
 * https://developer.mapquest.com/documentation/geocoding-api/
 * https://developer.mapquest.com/documentation/geocoding-api/address/get/

 * @example
 * const geocodeService = new geoGodeService();
 * geocodeService.getGeocode(address);
 */

export default class GeocodeService {
  /**
   * Returns request geocode
   * @param {address} object, based on API's 5-box input
   * In this method, parse object keys & values to construct string matching 5-box input
   * @example http://www.mapquestapi.com/geocoding/v1/address?key=KEY&street=1600+Pennsylvania+Ave+NW&city=Washington&state=DC&postalCode=20500
   * @returns {object} - response object with geocode data, including lat & long
   */
  public async getGeocode(
    address: { street: string, city: string, state: string, postalCode: string, country: string}
  ): Promise<{
    lat: number;
    lng: number;
  }> {
    let query = '';
    for (const [key, value] of Object.entries(address)) {
      let char = '';
      let loc = encodeURIComponent(value);
      loc = loc.replace(/\s/g, "+"); // request accepts spaces as '+' symbol  
      if (key === "street" || key === "city") {
        char = ',';
      } else if (key === "state" || key === "postalCode") {
        char = '+';
      }    
      query += `${loc}${char}`;
    }
    let geocode;
    try {
      const options = {
        withCredentials: false,
      };
      const res: AxiosResponse<any> = await axios.get(
        "https://www.mapquestapi.com/geocoding/v1/address?key=" +
          process.env.VUE_APP_GEOCODE_TOKEN +
          '&location=' +
          query, options
      );
      geocode = res.data.results[0].locations[0].latLng;
      if (geocode.lat == 0 || geocode.lng == 0) {
        throw new GeocodeError(
          "The address was not found. Please ensure it is correct and try again."
        );
      }
    } catch (err) {
      throw new GeocodeError("Error with geolocation service.");
    }
    return geocode;
  }
}
